import React, { Component } from 'react';
import fetch from 'cross-fetch';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';
import NavBar, { NextButton, SkipButton, BackButton } from './NavBar2.jsx';
import TextField from '../bits/TextField.jsx';

class AmazonVineForm extends Component {
  state = {
    isLoading: false,
    errorCode: null,
    vineOrderId: '',
  }

  nextDisabled = () => (this.state.vineOrderId.length < 1);

  handleSubmit = () => {
    const { vineOrderId } = this.state;
    const { handleChange, onNext } = this.props;

    this.setState({ isLoading: true });
    handleChange('validatedPromoCode')({ target: { value: '' } });

    fetch('/api/v2/promo-codes/validate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ code: vineOrderId }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        // Non 2XX response
        throw new Error('Failed to validate Amazon Order ID');
      })
      .then((json) => {
        handleChange('validatedPromoCode')({ target: { value: json.valid ? vineOrderId : '' } });

        this.setState({
          isLoading: false,
          errorCode: json.valid ? null : 'Unknown Amazon Order ID',
        });

        if (json.valid) {
          onNext();
        }
      })
      .catch((e) => {
        console.error(e);
        handleChange('validatedPromoCode')({ target: { value: '' } });

        this.setState({
          isLoading: false,
          errorCode: e,
        });
      });
  };

  handleSkip = () => {
    const { handleChange, onSkip } = this.props;

    handleChange('validatedPromoCode')({ target: { value: '' } });
    onSkip();
  }

  render() {
    const { onBack, t } = this.props;

    return (
      <div>
        <h2>{t('vine_entry_form.title')}</h2>
        <div className="form-group">
          <TextField
              id="vineOrderId"
              label={t('vine_entry_form.input_label')}
              placeholder="e.g 204-1234567-1234567"
              value={this.state.vineOrderId}
              onChange={e => this.setState({ vineOrderId: e.target.value })}
              fullWidth
              margin="normal"
              error={Boolean(this.state.errorCode)}
              helperText={t(this.state.errorCode)}
            />
          <p className="form-text text-muted">
            {t('vine_entry_form.instruction')}
          </p>
        </div>

      <NavBar>
          <NextButton
            isLoading={this.state.isLoading}
            onClick={this.handleSubmit}
            disabled={this.nextDisabled()}
          />
          <SkipButton onClick={this.handleSkip} />
          <BackButton onClick={onBack} />
      </NavBar>
      </div>
    );
  }
}

AmazonVineForm.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  onSkip: PropTypes.func,
  handleChange: PropTypes.func,
  values: PropTypes.object,
};


export default withTranslation('activation_wizard')(AmazonVineForm);
